import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  return {
    title: _defineProperty({
      /* default to none - since toggle moved to sidebar on non mobile */
      display: 'none',
      height: 'inherit'
    }, mq, {
      display: 'flex',
      alignItems: 'center'
    }),
    menuButton: {
      border: 'none',
      fontSize: componentTheme.menuButtonFontSize,
      color: componentTheme.menuButtonColor,
      background: 'transparent',
      height: 'inherit',
      '&:hover': {
        opacity: componentTheme.menuButtonHoverOpacity
      }
    }
  };
};
export default generateStyle;